import { NavLink } from 'react-router-dom'
import { Box, Breadcrumbs, Hidden, Icon, styled, useTheme } from '@mui/material'

// STYLED COMPONENTS
const BreadcrumbRoot = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
})

const BreadcrumbName = styled('h4')({
  margin: 0,
  fontSize: '16px',
  paddingBottom: '1px',
  verticalAlign: 'middle',
  textTransform: 'capitalize',
})

const SubName = styled('span')(({ theme }) => ({
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
}))

const Separator = styled('h4')(({ theme }) => ({
  margin: 0,
  marginLeft: 8,
  paddingBottom: '3px',
  color: theme.palette.text.hint,
}))

const StyledIcon = styled(Icon)({
  marginLeft: 8,
  marginBottom: '4px',
  verticalAlign: 'middle',
})

export default function Breadcrumb({ routeSegments, action }) {
  const theme = useTheme()
  const hint = theme.palette.text.hint

  // Filter out any segment explicitly named 'Home' to avoid duplication
  const filteredSegments =
    routeSegments?.filter(
      (segment) => segment?.name?.toLowerCase() !== 'home',
    ) || []

  return (
    <BreadcrumbRoot>
      <Hidden xsDown>
        <BreadcrumbName>Home</BreadcrumbName>
        <Separator>|</Separator>
      </Hidden>

      <Breadcrumbs
        separator={<Icon sx={{ color: hint }}>navigate_next</Icon>}
        sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
      >
        <NavLink to="/">
          <StyledIcon color="primary">home</StyledIcon>
        </NavLink>

        {filteredSegments.map((route, index) =>
          index !== filteredSegments.length - 1 ? (
            <NavLink key={index} to={route.path}>
              <SubName>{route.name}</SubName>
            </NavLink>
          ) : (
            <SubName key={index}>{route.name}</SubName>
          ),
        )}
      </Breadcrumbs>

      {action && <Box sx={{ marginLeft: 'auto' }}>{action}</Box>}
    </BreadcrumbRoot>
  )
}
